import { createActions, createReducer } from 'reduxsauce'
import { fromJS } from 'immutable'

const { Types, Creators } = createActions(
  {
    set: ['error'],
    clear: []
  },
  { prefix: 'react-commons/error/' }
)

export const creators = Creators
export const types = Types

const INITIAL_STATE = fromJS({})

const set = (state, { error }) => state.merge(error)
const clear = state => state.clear()

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET]: set,
  [Types.CLEAR]: clear
})
